import React from 'react';
import { styled } from '@ff/ui';
import FlexRow from '@ff/ui/FlexRow';
import FlexCol from '@ff/ui/FlexCol';
import Image from '@ff/ui/Image';
import Link from '@ff/ui/Link';
import Text from '@ff/ui/Text';
import type { Props as CardsProps } from './DoubleCards';
import type { BioCardProps } from './DoubleCards';
import TextEllipsis from 'shared/components/TextEllipsis';
import Profile from './Profile';
import ArrowSVG from './Icons/arrow.svg';

export default function MultipleCards(props: CardsProps) {
  const { readBio, bioList, textColor, onBioClick } = props;

  return (
    <Container>
      {bioList.map((item) => (
        <BioCard key={item.name} readBio={readBio} textColor={textColor} {...item} onBioClick={() => onBioClick(item)} />
      ))}
    </Container>
  );
}

function BioCard({ profileUrl, profileUrlAlt, profileRoundedCorner, profileModal, name, position, bio, readBio, link, textColor, onBioClick }: BioCardProps) {
  return (
    <BioCardContainer>
      <Profile
        readBio={readBio}
        maxWidth='420px'
        maxHeight='420px'
        profileUrl={profileUrl}
        profileUrlAlt={profileUrlAlt}
        profileRoundedCorner={profileRoundedCorner}
        profileModal={profileModal}
        link={link}
        onBioClick={onBioClick}
      />
      <TextContainer>
        <Title nameColor={textColor?.bioListColor?.nameColor}>{name}</Title>
        <Subtitle positionColor={textColor?.bioListColor?.positionColor}>{position}</Subtitle>
        <Description bioColor={textColor?.bioListColor?.bioColor} lineClamp='8'>{bio}</Description>
        {link && (
          <ArrowLink href={link}>
            <StyledArrow src={ArrowSVG} />
          </ArrowLink>
        )}
      </TextContainer>
    </BioCardContainer>
  )
}

const Container = styled(FlexRow)({
  marginTop: '26px',
  width: '90vw',
  maxWidth: '1438px',
  justifyContent: 'space-between',
  gap: '32px'
});

const BioCardContainer = styled(FlexCol)({
  maxWidth: '420px'
});

const TextContainer = styled(FlexCol)({
  justifyContent: 'center',
  maxWidth: '556px'
});

const Title = styled(Text)<{ nameColor: string }>(({ nameColor }) => ({
  color: nameColor || 'white',
  fontSize: '17px',
  fontWeight: 500,
  lineHeight: '24px',
  marginTop: '16px',
  marginBottom: '2px'
}));

const Subtitle = styled(Text)<{ positionColor: string }>(({ positionColor }) => ({
  color: positionColor || '#C9C9D1',
  fontSize: '14px',
  lineHeight: '22px',
  marginBottom: '16px'
}));

const Description = styled(TextEllipsis)<{ bioColor: string }>(({ bioColor }) => ({
  color: bioColor || 'rgba(255, 255, 255, 0.67)',
  fontSize: '14px',
  lineHeight: '22px',
}));

const ArrowLink = styled(Link)({
  marginTop: '24px',
  width: 'fit-content',
});

const StyledArrow = styled(Image)({
  height: '14px',
  width: '14px',
});
